// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__sro5X","fileDisabled":"File_fileDisabled__YdJli"};